import { sizes } from '@rio/sizes'

export const Sizes = Object.keys(sizes.values).reduce((acc, key) => {
  return { ...acc, [key]: `var(--${sizes.cssVarPrefix}-${key.toLowerCase()})` }
}, {} as Record<keyof typeof sizes.values, string>)

export default Sizes
